export const upperCaseFirstLetter = (s: string) =>
  s.charAt(0).toUpperCase() + s.slice(1)
